import axios from 'axios';
import { BASE_URL } from 'utils/constants/Api';

import {
  IFilters,
  IShipmentResData,
  ShipmentSearchCriteriaDto,
} from '@project44-models/shipment-list';

export async function fetchSearch(body: IFilters) {
  const data = await axios.post(`${BASE_URL}/search`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data?.data;
}

export async function fetchShipments(payload?: ShipmentSearchCriteriaDto) {
  const { data } = await axios.post<IShipmentResData>(
    `${BASE_URL}/shipments`,
    payload?.toJSON(),
    {
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
      },
    },
  );

  return data;
}

export async function getCount(body?: IFilters) {
  const data = await axios.post(`${BASE_URL}/search/count`, body, {
    withCredentials: true,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  return data?.data?.paginationInfo.total || 0;
}
